import { call, put, takeEvery, takeLatest, select } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eAppMenuTruongActionTypeIds, IAppMenuTruongAddMenuStart, IAppMenuTruongDeleteStart, IAppMenuTruongLoadMenuTeacherStart, IAppMenuTruongLoadStart, IAppMenuTruongPermissionStart } from "../../action-types/app-phuhuynh/IAppMenuTruongActionTypes";
import { actions } from "../../actions/actionsWrapper";

const appMenuTruongApi = apiWrapper.appMenuTruong;

export function* appMenuTruongSaga(): any {
    yield takeLatest(eAppMenuTruongActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eAppMenuTruongActionTypeIds.LOAD_MENU_TEACHER_START, loadMenuTeacherWorker)
    yield takeEvery(eAppMenuTruongActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eAppMenuTruongActionTypeIds.ADD_APP_MENU_START, addMenuWorker)
    yield takeEvery(eAppMenuTruongActionTypeIds.PERMISSION_START, permissionWorker)
}
function* loadWorker(action: IAppMenuTruongLoadStart): any {

    const res: IBaseResponeModel = yield call([appMenuTruongApi, appMenuTruongApi.getAllAsync], action.payload)
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadSuccess(res.data))
    } else {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadError(res.message || "Không tải được chức năng"))
    }
}

function* loadMenuTeacherWorker(action: IAppMenuTruongLoadMenuTeacherStart): any {

    const res: IBaseResponeModel = yield call([appMenuTruongApi, appMenuTruongApi.getAllMenuTeacherAsync], action.payload)
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadMenuTeacherSuccess(res.data))
    } else {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadMenuTeacherError(res.message || "Không tải được chức năng giáo viên"))
    }
}

function* deleteWorker(action: IAppMenuTruongDeleteStart): any {
    const { dm_truong_id, app_menu_truong_ids } = action.payload;
    const res: IBaseResponeModel = yield call([appMenuTruongApi, appMenuTruongApi.deleteAppMenuAsync], { ids: app_menu_truong_ids })
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.deleteSuccess())
        const isTeacherPage = window.location.pathname.includes("teacher");
        if (isTeacherPage) {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadMenuTeacherStart(dm_truong_id))
        } else {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadStart(dm_truong_id))
        }
    } else {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.deleteError(res.message || "Không xóa được chức năng"))
    }
}
function* addMenuWorker(action: IAppMenuTruongAddMenuStart): any {
    const { dm_truong_id } = action.payload;
    const res: IBaseResponeModel = yield call([appMenuTruongApi, appMenuTruongApi.addAppMenuAsync], action.payload);
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.addMenuSuccess())
        const isTeacherPage = window.location.pathname.includes("teacher");
        if (isTeacherPage) {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadMenuTeacherStart(dm_truong_id))
        } else {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadStart(dm_truong_id))
        }
    } else {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.addMenuError(res.message || "Không lưu được nhóm chức năng"))
    }
}

function* permissionWorker(action: IAppMenuTruongPermissionStart): any {
    try {
        const request = action.payload;

        const res: IBaseResponeModel = yield call([appMenuTruongApi, appMenuTruongApi.updatePermissionAsync], request);

        if (res.is_success) {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.permissionSuccess());

            // Reload lại data để cập nhật UI
            const state = yield select((state: any) => state.common);
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.loadMenuTeacherStart(state.dm_truong_selected_id));
        } else {
            yield put(actions.appPhuHuynhWrapper.appMenuTruong.permissionError(res.message || "Không thể cập nhật phân quyền"));
        }
    } catch (error: any) {
        yield put(actions.appPhuHuynhWrapper.appMenuTruong.permissionError(error.message || "Lỗi khi phân quyền"));
    }
}